import { render, staticRenderFns } from "./StatusColumn.vue?vue&type=template&id=cc48a1bc&"
import script from "./StatusColumn.vue?vue&type=script&lang=ts&"
export * from "./StatusColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports